import logo from "../images/logo.png";
import powered_by_adv_logo from "../images/powered_by_adv_logo.png";
import powered_by_adv_dx_big_logo from "../images/powered_by_adv_dx_big_logo.png";
import dx_logo_big from "../images/DXLogoBig.png";
import TRG_logo from "../images/TRG_logo.png";

const tbdAccounts = [
  2622842, 2622841, 2622840, 2622829, 2622811, 2622826, 2622814, 2622792, 2622638, 2622799, 2622810, 2622847, 2622817,
  2622813, 2622831, 2622825, 2615604, 2622798, 2618625, 2622777, 2622839, 927, 2622855, 2620632,
];

const hasCyclePast = (progCycleId) => {
  const now = new Date();

  return (
    (progCycleId === 3 && now <= new Date("2026-07-31T23:59:59.999")) ||
    (progCycleId === 1 && now <= new Date("2026-08-05T23:59:59.999")) ||
    (progCycleId === 8 && now <= new Date("2026-08-07T23:59:59.999"))
  );
};

const getLogoImage = (accountId, isClosed, progCycleId, dxLogo, poweredByLogo) => {
  if (!accountId || accountId === -1 || tbdAccounts.includes(accountId) || isClosed || hasCyclePast(progCycleId)) {
    return dxLogo;
  } else {
    return poweredByLogo;
  }
};

export const getLogo = (accountId, isClosed, progCycleId) => {
  if (accountId === 2622646) {
    return TRG_logo;
  } else {
    return getLogoImage(accountId, isClosed, progCycleId, logo, powered_by_adv_logo);
  }
};

export const getAuthLogo = (accountId, isClosed, progCycleId) => {
  return getLogoImage(accountId, isClosed, progCycleId, dx_logo_big, powered_by_adv_dx_big_logo);
};
